const CLICK_MANAGEMENT_EXPERIENCE_TYPES = {
  DELETE: '[clickManagementExperience] deleteClick'
}

export default CLICK_MANAGEMENT_EXPERIENCE_TYPES
